// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2SYcZ","resendInfoText":"OnGoingPaymentBox_resendInfoText__2WJ2W"};